import { useFormikContext } from "formik";
import { InputAdornment, TextField } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { AddInvestmentFormValues } from "../../../types";

const QuantityField = () => {
  const { handleChange, values, errors, touched } =
    useFormikContext<AddInvestmentFormValues>();
  const isMobile = useMediaQuery("(max-width:1110px)");

  return (
    <>
      <TextField
        sx={{
          width: isMobile ? "100%" : "29%",
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginRight: 0,
          },
        }}
        id="quantity"
        name="quantity"
        label="Quantity"
        type="number"
        size="small"
        color="secondary"
        maxRows={1}
        autoComplete="off"
        fullWidth
        value={values["quantity"]}
        onChange={handleChange}
        error={
          (touched["quantity"] && Boolean(errors["quantity"])) ||
          (touched["unit"] && Boolean(errors["unit"]))
        }
        helperText={
          (touched["quantity"] && errors["quantity"]) ||
          (touched["unit"] && errors["unit"])
        }
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment data-testid="unitAdornment" position="start">
                {values.unit ? values.unit : null}
              </InputAdornment>
            ),
          },
        }}
      />
    </>
  );
};

export default QuantityField;
